<template>
	<div>
		<v-data-table :headers="fieldList" :items="entityList" sort-by="name" :search="keyword" :footer-props="{ itemsPerPageOptions: [50,100,500,-1] }">
			<template v-slot:top>
				<v-row no-gutters style="padding:5px 0 0 0;">
					<v-col cols="12" sm="6">
						<div class="d-flex px-2">
							<h2>Tenant List</h2>
						</div>
					</v-col>
					<v-col></v-col>
					<v-col cols="12" sm="6">
						<div class="d-flex px-2">
							<v-text-field v-model="keyword" append-icon="mdi-magnify" label="Search" hide-details style="margin-right:10px;"></v-text-field>
							<v-btn fab x-small color="primary" @click="showAdd">
								<v-icon>mdi-plus</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</template>
			<template v-slot:item.active="{ item }">{{ item.active ? "Active" : "Inactive" }}</template>
			<template v-slot:item.action="{ item }">
				<v-btn fab x-small link :to="'/administrator/tenant/' + item.id + '/staff'">
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-btn>
                    <v-btn fab x-small style="margin-left: 10px" @click="showEdit(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn fab x-small style="margin-left: 10px" @click="showDelete(item.id)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
			</template>
			<template v-slot:no-data>Empty list</template>
		</v-data-table>

		<v-dialog v-model="dialogAdd.show" max-width="500">
			<v-card>
				<v-card-title>{{ dialogAdd.title }}</v-card-title>

				<v-form class="px-5">
					<v-text-field v-model="entityAdd.name" label="Name" @input="createUrl(entityAdd.name, false)"></v-text-field>
					<v-text-field v-model="entityAdd.slug" label="URL" hint="Must be lower case alphanumeric with no spaces"></v-text-field>
					<v-text-field v-model="entityAdd.masterPassword" label="Master Password" hint="Login as any tenant staff using this master password"></v-text-field>
					<v-text-field v-model="entityAdd.notificationEmail" label="Notification Email" :rules="[rules.required, rules.email]"></v-text-field>
					<div style="height: 10px"></div>
					<v-select v-model="entityAdd.type" :items="types" label="Membership Type" dense outlined>
						<template v-slot:selection="{ item }">
							<span>{{ item.replace("_", " ") }}</span>
						</template>
						<template v-slot:item="{ item }">
							<span>{{ item.replace("_", " ") }}</span>
						</template>
					</v-select>
					<v-select
						v-model="entityAdd.tenantPlanId"
						:items="tenantPlanList.filter((plan) => plan.type === entityAdd.type)"
						label="Membership Plan"
						dense
						outlined
						item-text="name"
						item-value="id"
					></v-select>
					<v-row>
						<v-col cols="9">
							<v-select
								v-model="poweredBy.level"
								:items="poweredByLevelsAdd"
								label="Powered By Toggle"
								dense
								outlined
								item-text="name"
								item-value="id"
								hide-details=""
							></v-select>
						</v-col>
						<v-col cols="3">
							<v-switch
								v-model="poweredBy.active"
								:label="poweredBy.active ? 'On' : 'Off'"
								hide-details=""
								style="margin-top: 5px"
							></v-switch>
						</v-col>
					</v-row>
					<v-switch v-model="entityAdd.active" :label="entityAdd.active ? 'Active' : 'Inactive'"></v-switch>
				</v-form>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogAdd.show = false">Cancel</v-btn>
					<v-btn color="primary" @click="add">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit.show" max-width="500">
			<v-card>
				<v-card-title>{{ dialogEdit.title }}</v-card-title>

				<v-form class="px-5">
					<v-text-field v-model="entityEdit.name" label="Name" @input="createUrl(entityEdit.name, true)"></v-text-field>
					<v-text-field v-model="entityEdit.slug" label="URL" hint="Must be lower case alphanumeric with no spaces"></v-text-field>
					<v-text-field v-model="entityEdit.masterPassword" label="Master Password" hint="Login as any tenant staff using this master password"></v-text-field>
					<v-text-field v-model="entityEdit.notificationEmail" label="Notification Email" :rules="[rules.required, rules.email]"></v-text-field>
					<div style="height: 10px"></div>
					<v-select v-model="entityEdit.type" :items="types" label="Membership Type" @change="updateTenantPlanList()" dense outlined>
						<template v-slot:selection="{ item }">
							<span>{{ item.replace("_", " ") }}</span>
						</template>
						<template v-slot:item="{ item }">
							<span>{{ item.replace("_", " ") }}</span>
						</template>
					</v-select>
					<v-select v-model="entityEdit.tenantPlanId" :items="editTenantPlanList" item-text="name" item-value="id" label="Membership Plan" dense outlined></v-select>
					<v-row>
						<v-col cols="9">
							<v-select
								v-model="poweredBy.level"
								:items="poweredByLevels"
								label="Powered By Toggle"
								dense
								outlined
								item-text="name"
								item-value="id"
								hide-details=""
								@change="changeAllPoweredBy"
							></v-select>
						</v-col>
						<v-col cols="3">
							<v-switch
								v-model="poweredBy.active"
								:label="poweredBy.active ? 'On' : 'Off'"
								hide-details=""
								style="margin-top: 5px"
								@change="changeAllPoweredBy"
								:disabled="poweredBy.level != 'Tenant_Level'"
							></v-switch>
						</v-col>
					</v-row>
					<div >
						Experience List
						<div style="border: 1px solid #9e9e9e; border-radius: 5px; min-height:100px;max-height:150px; overflow-y: auto;overflow-x: hidden;">
							<v-row v-for="(item, index) in poweredBy.experienceList" :key="index">
								<v-col cols="9" style="padding: 7px 0px 0px 20px">
									<span class="mt-2"> {{item.name}}</span>
								</v-col>
								<v-col cols="3" style="padding: 0px 0px 0px 10px">
									<v-switch
										v-model="item.active"
										:label="item.active ? 'On' : 'Off'"
										hide-details=""
										style="margin-top: 4px"
										:disabled="poweredBy.level == 'Tenant_Level'"
										@change="changePoweredBy"
									></v-switch>
								</v-col>
                                <v-col cols="9" class="px-5 pt-0">
                                    <v-text-field
                                        v-model="item.footerText"
                                        :label="item.name + ' footer text'"
                                        :disabled="poweredBy.level == 'Tenant_Level'"
                                    />
                                </v-col>
							</v-row>
						</div>
					</div>
					<v-switch v-model="entityEdit.active" :label="entityEdit.active ? 'Active' : 'Inactive'"></v-switch>
				</v-form>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogEdit.show = false">Cancel</v-btn>
					<v-btn color="primary" @click="edit">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDelete.show" max-width="500">
			<v-card>
				<v-card-title>{{ dialogDelete.title }}</v-card-title>

				<v-card-text class="px-5">{{ dialogDelete.content }}</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDelete.show = false">Cancel</v-btn>
					<v-btn color="accent" @click="remove">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<style>
</style>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";

export default {
	data() {
		return {
			dialogAdd: { show: false, title: "Add new tenant" },
			dialogEdit: { show: false, title: "Edit tenant" },
			dialogDelete: {
				show: false,
				title: "Delete tenant",
				content: "Are you sure you want to delete this tenant?"
			},
			entityAdd: { active: true, dataMap: {poweredBy: {level: "Tenant_Level", active: true, experienceList: []}}},
			entityEdit: { active: true, dataMap: {poweredBy: {level: "Tenant_Level", active: true, experienceList: []}}},
			entityDelete: {},
			entityList: [],
			types: [],
			tenantPlanList: [],
			editTenantPlanList: [],
			selectedTenantPlan: null,
			fieldList: [
				{ text: "Name", value: "name" },
				{ text: "URL", value: "slug" },
				{ text: "Tenant Type", value: "dataMap.tenantPlanType" },
				{ text: "Tenant Plan", value: "dataMap.tenantPlanName" },
				{ text: "Notification Email", value: "notificationEmail" },
				{ text: "Status", value: "active" },
				{ text: "", value: "action", sortable: false }
			],
			keyword: "",
			tenantSlugList:[],
			entityEditOld:{},
			rules: {
				required: (v) => !!v || "Required.",
				email: (v) => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(v) || "Invalid e-mail.";
				}
			},
			footerLevel: "Tenant_Level",
			poweredByLevelsAdd: [
				{ id : "Tenant_Level", name: "Tenant"}
			],
			poweredByLevels: [
				{ id : "Tenant_Level", name: "Tenant"},
				{ id : "Experience_Level", name: "Experience"}
			],
			poweredBy: {
				level: "Tenant_Level",
				active: true,
				experienceList: []
			}
		};
	},
	mounted: function() {
		this.list();
	},
	methods: {
		listMembershipType() {
			axios.get("/system/enumeration/membership/type/list").then(response => {
				this.types = response.data;
			});
		},
		listTenantPlan() {
			this.tenantPlanList = [];
			axios.get("/system/tenantplan/list").then(response => {
				this.tenantPlanList = response.data;
			});
		},
		list() {
			axios
				.get("/system/tenant/list/join/tenantplan")
				.then(response => {
					this.entityList = response.data;
					this.listMembershipType();
					this.listTenantPlan();
					this.listSlug();
				})
				.catch(() => {});
		},
		showAdd() {
			this.entityAdd = { active: true, dataMap: {poweredBy: {level: "Tenant_Level", active: true, experienceList: []}}};
			this.dialogAdd.show = true;
			this.poweredBy = {level: "Tenant_Level", active: true, experienceList: []};
		},
		add() {
			this.entityAdd.dataMap.poweredBy = this.poweredBy;
			axios
				.post("/system/tenant/add", {
					entity: this.entityAdd
				})
				.then(response => {
					this.list();
					this.dialogAdd.show = false;
				})
				.catch(() => {});
		},
		showEdit(entity) {
			this.entityEdit = {
				id: entity.id,
				name: entity.name,
				slug: entity.slug,
				active: entity.active,
				tenantPlanId: entity.tenantPlanId,
				masterPassword: entity.masterPassword,
				notificationEmail: entity.notificationEmail,
				dataMap: {}
			};

			this.poweredBy = entity.dataMap.poweredBy == null ?
				{level: "Tenant_Level", active: true, experienceList: []}
				: entity.dataMap.poweredBy;

            let jsonData = JSON.parse(entity.data);
            let dataExpList = jsonData.poweredBy.experienceList.length > 0
                ? jsonData.poweredBy.experienceList
                : null;

			axios
				.get("/system/experience/list?tenantId=" + this.entityEdit.id)
				.then((response) => {
					let dbExperienceList = response.data;
					let newExperienceList = [];

					for (let dbExperience of dbExperienceList) {
                        let tempFooterText = null;

                        if (dataExpList) {
                            if (dataExpList.findIndex(item => item.id === dbExperience.id) >= 0) {
                                tempFooterText = dataExpList[dataExpList.findIndex(
                                    item => item.id === dbExperience.id
                                )].footerText;
                            }
                        }

						let newExperience = {
								id: dbExperience.id,
								name: dbExperience.name,
								active: this.poweredBy.level == true,
                                footerText: tempFooterText
							}

						if (this.poweredBy != 'Tenant_Level') {
							newExperience.active = false;
							for (let experience of this.poweredBy.experienceList) {
								if (dbExperience.id == experience.id) {
									newExperience.active = experience.active;
								}
							}
						}
						newExperienceList.push(newExperience)
					}
					this.poweredBy.experienceList = newExperienceList;
					this.changeAllPoweredBy();
				})
				.catch(() => {});

			this.entityEditOld = this.$root.clone(this.entityEdit);
			axios
				.post("/system/tenantplan", {
					id: this.entityEdit.tenantPlanId
				})
				.then(response => {
					this.selectedTenantPlan = response.data;
					this.entityEdit.type = this.selectedTenantPlan.type;
					this.editTenantPlanList = this.tenantPlanList.filter(x => x.type === this.entityEdit.type);
				})
				.catch(() => {});
			this.dialogEdit.show = true;
		},
		updateTenantPlanList() {
			this.editTenantPlanList = this.tenantPlanList.filter(x => x.type === this.entityEdit.type);
		},
		edit() {
			this.entityEdit.dataMap.poweredBy = this.poweredBy;

			axios
				.post("/system/tenant/edit", {
					entity: this.entityEdit
				})
				.then(response => {
					this.dialogEdit.show = false;
					this.list();
					this.entityEditOld={};
				})
				.catch(() => {});
		},
		showDelete(entityId) {
			this.entityDelete.id = entityId;
			this.dialogDelete.show = true;
		},
		remove() {
			axios
				.post("/system/tenant/delete", { id: this.entityDelete.id })
				.then(response => {
					this.list();
					this.dialogDelete.show = false;
				})
				.catch(() => {});
		},
		listSlug() {
			this.tenantSlugList = [];
			for (let tenant of this.entityList) {
				this.tenantSlugList.push(tenant['slug'].toLowerCase());
			}
			this.tenantSlugList.sort();
			this.tenantSlugList.reverse();
		},
		createUrl(name, isUpdate){
			let slug = name ? name.toLowerCase().replace(/ /g, ''): null;
			let tenantSlugMap = {};
			for (let i of this.tenantSlugList) {
				tenantSlugMap[i] = true;
			}

			let match = new RegExp("^(.*)([0-9]+)$").exec(slug);
			let word = slug;
			let number = '';

			if (match != null) {
				word = match[1];
				number = Number(match[2]); // handle 09, 009, 0009 and so on
			}

			while (tenantSlugMap[word + '' + number]) {
				// increment
				if (number == '') {
					number = 1;
				} else {
					number++;
				}
			}

			slug = word + '' + number;
			slug = slug == 'null' ? '' : slug;

			if (isUpdate) {
				if (name.toLowerCase() == this.entityEditOld.name.toLowerCase()) {
					this.entityEdit.slug = this.entityEditOld.slug;

				} else {
					this.entityEdit.slug = slug;
				}
			} else {
				this.entityAdd.slug = slug;
			}
		},
		changeAllPoweredBy() {
			if (this.poweredBy.level === 'Tenant_Level') {
				for (let experience of this.poweredBy.experienceList) {
					experience.active = this.poweredBy.active;
				}
			}
		},
		changePoweredBy() {
			let active = false;
			for (let experience of this.poweredBy.experienceList) {
				if (experience.active) {
					active = experience.active;
				}
			}
			this.poweredBy.active = active;
		},
	}
};
</script>
